import React from 'react';
import { Helmet } from 'react-helmet-async';

const CookiesPage: React.FC = () => (
  <>
    <Helmet>
      <title>Cookie Policy | VB Entreprise | Premium IT & Digital Marketing Agency for US, UK & Canada Businesses</title>
    </Helmet>
    <div className="max-w-3xl mx-auto px-4 py-16">
      <h1 className="text-4xl font-bold text-gray-900 mb-6">Cookie Policy</h1>
      <p className="text-gray-700 mb-6">
        This Cookie Policy explains how <strong>VB Unified Entreprise OPC Private Limited</strong> ("we", "us", or "our") uses cookies and similar technologies on our website.
      </p>
      <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-2">1. What Are Cookies?</h2>
      <p className="text-gray-700 mb-4">
        Cookies are small text files stored on your device when you visit a website. They help us remember your preferences, improve your experience, and analyze site usage.
      </p>
      <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-2">2. Types of Cookies We Use</h2>
      <ul className="list-disc ml-6 text-gray-700 mb-4">
        <li><strong>Essential Cookies:</strong> Necessary for the website to function properly.</li>
        <li><strong>Analytics Cookies:</strong> Help us understand how visitors interact with our site.</li>
        <li><strong>Marketing Cookies:</strong> Used to deliver relevant ads and track campaign performance.</li>
        <li><strong>Functional Cookies:</strong> Enable enhanced features and personalization.</li>
      </ul>
      <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-2">3. Managing Cookies</h2>
      <ul className="list-disc ml-6 text-gray-700 mb-4">
        <li>You can control or delete cookies through your browser settings.</li>
        <li>Disabling cookies may affect your experience on our site.</li>
        <li>You can update your cookie preferences at any time using our cookie consent banner.</li>
      </ul>
      <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-2">4. Third-Party Cookies</h2>
      <p className="text-gray-700 mb-4">
        We may use third-party services (e.g., analytics, advertising) that set their own cookies. We do not control these cookies.
      </p>
      <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-2">5. Changes to This Policy</h2>
      <p className="text-gray-700 mb-4">
        We may update this Cookie Policy from time to time. The latest version will always be posted on this page.
      </p>
      <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-2">6. Contact</h2>
      <p className="text-gray-700">
        For questions about our use of cookies, please contact us at <a href="mailto:contact@vb-entreprise.com" className="text-jordy-blue-600 underline">contact@vb-entreprise.com</a>.<br/>
        <span className="block mt-2">VB Unified Entreprise OPC Private Limited</span>
      </p>
    </div>
  </>
);

export default CookiesPage; 